import { FC, useEffect, useRef } from "react";
import AuthenticationBloc from "src/state/UserCubit/AuthenticationBloc";
import UserCubit from "src/state/UserCubit/UserCubit";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";
import { useBloc } from "src/state/state";
import {
  AppQueryPopupsController,
  AppPopup
} from "../AppQueryPopups/AppQueryPopupsBloc";
import reportErrorSentry from "src/lib/reportErrorSentry";
import { AuthenticationMethod } from "../WithAuth/WithAuthCubit";

const SessionConfirmationCheck: FC = () => {
  const hasPerformedCheck = useRef(false);

  const [{ authenticationStatus }] = useBloc(AuthenticationBloc);
  const [{ userData }] = useBloc(UserCubit);
  const [, { loadUserPreferences, firstName, lastName }] =
    useBloc(UserPreferencesCubit);

  useEffect(() => {
    if (hasPerformedCheck.current) {
      return;
    }

    const checkSessionConfirmation = async () => {
      try {
        // Load user preferences to ensure we have the latest data
        await loadUserPreferences();
      } catch (error) {
        reportErrorSentry(error);
        return;
      }

      if (!userData) {
        return;
      }

      // Only check if user is authenticated
      if (authenticationStatus !== "authenticated") {
        return;
      }

      hasPerformedCheck.current = true;

      if (
        userData.sessionAuthenticationMethod &&
        [
          AuthenticationMethod.TRANSCARENT_SSO,
          AuthenticationMethod.SAML2,
          AuthenticationMethod.GOOGLE
        ].includes(userData.sessionAuthenticationMethod)
      ) {
        return;
      }

      // Show confirmation if user has both first and last names
      if (firstName && lastName) {
        AppQueryPopupsController.openPopup(AppPopup.sessionConfirmation);
      }
    };

    void checkSessionConfirmation();
  }, [authenticationStatus, userData, firstName, lastName, hasPerformedCheck]);

  return null;
};

export default SessionConfirmationCheck;
